import React from 'react'
import { DcInput, PixelCurrency } from 'pixel-base'
import styled from 'styled-components'

import { HeaderTitle, TableHeader } from './MergeOrders'

interface ISplitDiscountProps {
  item: {
    discount_code: string
    amount: number
    order_discount_line_id: number
  }
  index: number
}

const SplitDiscount = (props: ISplitDiscountProps) => {
  const { item, index } = props
  return (
    <Container>
      {index === 0 && (
        <TableHeader>
          <HeaderTitle width={'80%'}>Discount Lines</HeaderTitle>
          <HeaderTitle width={'20%'}>Total</HeaderTitle>
        </TableHeader>
      )}
      <Product>
        <ProductDetails>
          <ProductSection>{item.discount_code}</ProductSection>
        </ProductDetails>

        <Total>
          <PixelCurrency value={item.amount} />
        </Total>
      </Product>
    </Container>
  )
}
interface ISubDiscountProps {
  item: {
    discount_code: string
    amount: number
    order_discount_line_id: number
  }
  index: number
  onUpdateMethod: (value: number, order_discount_line_id: number) => void
}
const SubDiscount = (props: ISubDiscountProps) => {
  const { item, index, onUpdateMethod } = props
  return (
    <Container>
      {index === 0 && (
        <TableHeader>
          <HeaderTitle
            style={{
              marginLeft: '15px',
            }}
            width={'40%'}
          >
            Total
          </HeaderTitle>
        </TableHeader>
      )}
      <Product>
        <Total style={{ width: '40%', padding: '5px', marginLeft: '15px' }}>
          <DcInput
            required
            isShowLabel={false}
            type={'number'}
            name={'amount'}
            noPadding
            placeholder={
              item.discount_code === 'fixed_amount' ? 'Amount' : 'Percentage'
            }
            value={item.amount}
            min={0}
            max={item.discount_code === 'percentage' ? 100 : undefined}
            onChange={(e) => {
              onUpdateMethod(e.target.value, item.order_discount_line_id)
            }}
          />
        </Total>
      </Product>
    </Container>
  )
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
`
export const Product = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  font-size: 12px;

  gap: 10px;
  padding: 5px;
  height: 50px;
`
const ProductDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  width: 80%;
  gap: 10px;
`
const ProductSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: center;
  gap: 2px;
  width: 100%;
  /* padding: 10px 0px; */
`

const Total = styled.div`
  width: 20%;
  display: flex;
  flex-direction: row;
`
export { SplitDiscount, SubDiscount }
